module.exports = __webpack_public_path__ + "img/checkout-confirm-arrow.fe243c47.svg";